import React, { useState, useEffect, useMemo, useRef } from 'react'
import { Divider, Space, Modal, Button, Form } from '@bedrock/components'
import classNames from 'classnames/bind'
import SFormElement from "@mpc/common/src/components/SForm/SFormElement";
import { useMemoizedFn } from "ahooks"
import styles from './index.less'
import { Download } from '@bedrock/icons-react';
import { $sType } from "@mpc/common/src/utils/sType";
import axios from 'axios';
import { currencyEnum } from '#utils/number';
import moment from 'moment';
import { AgreeCheckBox } from '#components';
import BiddingAgreeCheckbox from '#features/Bidding/BiddingAgreeCheckbox';

const defaultPathMap = {
    inner: {
        action: '/api/v2/java_proxy/attachments/upload',
        downLoadPath: '/api/v2/java_proxy/attachments/',
    },
    outer: {
        action: '/api/outsource/v2/java_proxy/attachments/upload',
        downLoadPath: '/api/outsource/v2/java_proxy/attachments/',
    }
}

const cx = classNames.bind(styles)

type Props = {
    detail?: any
    isShow?: boolean,
    isList?: boolean,
    onClose?: () => void,
    updateAnnouncementList?: (params: any) => Promise<any>
    refresh?: () => void,
    getList?: () => void,
    id?: number
}

const Index = (props: Props) => {
    const { isShow = false, isList = true, onClose, detail = [], updateAnnouncementList, refresh, getList, id } = props
    const [loading, setLoading] = useState(false)
    const [disabled, setDisabled] = useState(false)
    const [selectedIndex, setSelectIndex] = useState(0)
    const [hoverIndex, setHoverIndex] = useState(0)
    const [state, setState] = useState('yes')
    const [allValues, setStateAllValues] = useState({
        bidding_nda_attachments: []
    })
    const [form] = Form.useForm()
    let confirmRef = null

    const agreeCheckBoxRef = useRef<any>(null)
    const [agree, setAgree] = useState(false)

    useEffect(() => {
        form.setFieldsValue({
            bidding_nda_attachments: detail?.[selectedIndex]?.bidding_nda_attachments
        })
    }, [selectedIndex, detail])

    const handleMouseMove = (index) => {
        setHoverIndex(index)
    }
    const handleMouseOut = (index) => {
        setHoverIndex(null)
    }

    const handleValuesChange = useMemoizedFn((values, allValues) => {
        setStateAllValues(allValues)
    })

    const openConfirmModal = React.useCallback((title, type, data) => {
        const confomDo = Modal.confirm(
            {
                status: 'info',
                title,
                content: '',
                centered: true,
                onOk: async () => {
                    const { bidding_id, bidding_supplier_id } = detail?.[selectedIndex];
                    setLoading(true)
                    const params: any = {
                        id: bidding_id,
                        state: 'awaiting_bidding',
                        bidding_action: 'SUBMIT',
                        pass: true,
                        form: {
                            bidding_supplier_id,
                            nda_blob_ids: data?.bidding_nda_attachments?.map(item => item?.blob?.id)
                        },
                    };
                    if (type === 'yes') {
                        params.form.is_willing_invite = true;
                    }
                    if (type === 'no') {
                        params.form.is_willing_invite = false;
                    }
                    try {
                        await updateAnnouncementList(params);
                        detail?.splice(selectedIndex, 1)
                        if (selectedIndex + 1 >= detail.length) {
                            setSelectIndex(detail.length - 1)
                        }
                        if (id || !detail.length) {
                            onClose()
                        } else {
                            getList();
                        }
                        refresh();
                    } finally {
                        setLoading(false)
                        confomDo?.destroy()
                    }
                },
            },
        );
    }, [selectedIndex, detail]);

    const handleUpload = useMemoizedFn(() => {
        let url;
        const defaultPath = defaultPathMap[$sType]
        const file = detail?.[selectedIndex]?.bidding_nda_template_attachments
        file.forEach(async (item) => {
            const id = item?.id || item?.blob.id
            const isBlob = id === item?.blob.id ? true : false
            const result = await axios.get(`${defaultPath.downLoadPath}${id}/url?download=attachment&isBlob=${isBlob}`)
            url = result.data?.data
            window.open(url, '_blank')
        })
    })

    const announcement = useMemo(() => {
        const {
            product_identifier = '',
            expect_begin_at = '',
            product_name = '',
            expect_end_at = '',
            name = '',
            budget = '',
            budget_currency = '',
            bid_registration_deadline = '',
            bid_proposal_deadline = '',
        } = detail?.[selectedIndex];
        return `${product_identifier} ${product_name}, ${expect_begin_at} / ${expect_end_at}, ${name} 需求比选,项目预算 ${budget} ${currencyEnum[budget_currency?.toLocaleLowerCase()]
            }, 比选方案及报价单提交截止日期 ${bid_proposal_deadline}, 请有意合作供应商于 ${bid_registration_deadline} 前, 接受比选需求，审核通过后可获取详细比选资料。`;
    }, [detail, selectedIndex]);

    return (
        <div className={cx('bidding-modal')}>
            {isShow && isList &&
                <div className={cx('bidding-modal-left-box')}>
                    <Space
                        direction='vertical'
                        size={4}
                        className={cx('bidding-modal-left')}
                    >
                        {detail?.map((item, index) => {
                            return (
                                <Space
                                    direction='vertical' size={4}
                                    className={cx('bidding-modal-left-item', {
                                        'hovered': hoverIndex === index,
                                        'selected': selectedIndex === index,
                                    })}
                                    onMouseMove={() => { handleMouseMove(index) }}
                                    onMouseOut={() => { handleMouseOut(index) }}
                                    onClick={() => { setSelectIndex(index) }}
                                >
                                    <div className={cx('title')}>{item.name}</div>
                                    <div className={cx('time')}>{moment(item.bid_registration_deadline).format('YYYY-MM-DD')}</div>
                                </Space>
                            )
                        })}
                    </Space>
                    <Divider style={{ height: '100%', margin: '0px 12px' }} mode="solid" bold={false} type='vertical' color='deep' />
                </div>
            }
            <div className={cx('bidding-modal-right')}>
                <div className={cx('bidding-content')}>
                    <Space className={cx('bidding-modal-banner')} size={10} direction='vertical'>
                        <div className={cx('bidding-modal-img')}>
                            <div className={cx('title')}>{detail?.[selectedIndex]?.name}</div>
                            <div>比选邀请</div>
                            <img src='https://dep559.gsf.netease.com/mpc_banner001.png' alt="" />
                        </div>
                        <div className={cx('bidding-modal-banner-time')}>{moment(detail?.[selectedIndex]?.expect_begin_at).format('YYYY-MM-DD')}</div>
                    </Space>
                    <div className={cx('bidding-modal-body', {
                        'isneed-nda': !detail?.[selectedIndex]?.need_nda
                    })}>{detail?.[selectedIndex]?.competition_announcement || announcement}</div>

                    {
                        detail?.[selectedIndex]?.need_nda && <>
                            <Divider mode="solid" bold={false} type='horizontal' color='deep' style={{ flex: '0 0 auto' }} />
                            <div className={cx('bidding-modal-upload-box')}>
                                <Form onValuesChange={handleValuesChange} layout='vertical' form={form} showLabelColon>
                                    <Form.Item
                                        rules={[{ required: state === 'yes', message: '请上传保密协议' }]}
                                        name={'bidding_nda_attachments'}
                                        label='保密协议'>
                                        <SFormElement
                                            style={{ maxWidth: 400}}
                                            className={cx('upload-file')}
                                            fileSizeLimit={50 * 1024 * 1024}
                                            onChange={e => {
                                                if (e && e.length) {
                                                    setDisabled(true)
                                                    const done = e.every(item => item.status === 'done')
                                                    if (done) {
                                                        setDisabled(false)
                                                    } else {
                                                        setDisabled(true)
                                                    }
                                                }
                                            }}
                                            tip={<div>
                                                <span>单个文件不能超过50M</span>
                                                <span style={{ display: 'inline-block', marginLeft: 12 }}><Button onClick={handleUpload} type='link' icon={<Download />}>下载保密协议模版</Button></span>
                                            </div>}
                                            formItemKey={`bidding_nda_attachments`}
                                            componentClass="upload"
                                        />
                                    </Form.Item>

                                </Form>
                            </div>
                        </>
                    }
                </div>

                {isShow && <div className={cx('bidding-modal-footer')}>
                    <BiddingAgreeCheckbox
                        ref={agreeCheckBoxRef}
                        value={agree}
                        onChange={setAgree}
                    />
                    <Space size={12} className={cx('bidding-modal-footer-btns')}>
                        <Button
                            type="primary"
                            danger
                            loading={loading}
                            disabled={disabled}
                            onClick={() => {
                                setState('no')
                                openConfirmModal('确定不接受该比选邀请吗', 'no', form.getFieldsValue())
                            }}
                        >不接受</Button>
                        <Button
                            type="primary"
                            loading={loading}
                            disabled={disabled}
                            onClick={async () => {
                                const checked = await agreeCheckBoxRef.current?.getChecked()
                                if (!checked) {
                                    return
                                }
                                setState('yes')
                                const data = await form.validateFields()
                                openConfirmModal('确定接受该比选邀请吗', 'yes', data)
                            }}
                        >接受</Button>
                    </Space>
                </div>}
            </div>
        </div>
    )
}

export default Index;